'user strict';

$('.header-login-page').on('click', function () {
    var noRedirect = [
        'CSRF-AjaxFail',
        'CSRF-Fail',
        'CSRF-Generate',
        'Error-Forbidden',
        'Error-Start',
        'Error-ErrorCode',
        'Default-Offline',
        'Login-Show',
        'Login-Logout',
        'Account-CompleteLeave',
        'Account-SignOutCompleted',
        'Login-RegisterStep1',
        'Login-RegisterStep2',
        'Login-RegisterStep3',
        'Login-MemberStep1',
        'Login-MemberStep2',
        'Login-MemberStep3'
    ];
    var action = $('.page').data('action');
    if (navigator.appName == 'Microsoft Internet Explorer' ||  !!(navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/rv:11/)) || (typeof $.browser !== "undefined" && $.browser.msie == 1)) {
        // check redirect on the IE browser
        var url = $('.header-login-page').data('url');
        if (noRedirect.indexOf(action) === -1) {
            url = $('.header-login-page').data('url') + '?redirect=' + encodeURIComponent(window.location.href);
        }
    } else {
        var url = new URL($('.header-login-page').data('url'));
        if (noRedirect.indexOf(action) === -1) {
            var redirectURL = encodeURIComponent(window.location.href);
            url.searchParams.set('redirect', redirectURL);
        }
    }

    window.location = url.toString();
});
